import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './index.css';
import {BrowserRouter} from 'react-router-dom';
import { AuthorizationProvider } from './context/authorizationContext';

ReactDOM.render(
    <>
        <BrowserRouter>
            <AuthorizationProvider>
                <App />
            </AuthorizationProvider>
        </BrowserRouter>
    </>
    , document.getElementById("root")
)